import numberFormat from "./numberFormat";

export default function discountFormat(value) {
    return value < 1 ? `${value*100}%` : numberFormat(value)
}